var _rect, _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXrp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 27,
    r: 7.11111,
    fill: "#226ED4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6667,
    cy: 37.2222,
    r: 7.11111,
    fill: "#226ED4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6667,
    cy: 16.7778,
    r: 7.11111,
    fill: "#226ED4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5555 23.6312C22.5555 23.6312 23.4444 26.1111 25.6667 26.1111C27.8889 26.1111 28.7778 24.2696 28.7778 23C28.7778 21.7304 27.5663 19.8889 27.5663 19.8889L35.1454 21.8956L34.1199 23.8889C34.1199 23.8889 31.4444 24.6341 31.4444 27C31.4444 29.3659 33.6842 30.1304 34.1199 30.1304C34.5555 30.1304 34.8865 30.8419 34.8865 30.8419L27.8842 33.0881C27.8842 33.0881 28.7778 32.2727 28.7778 31C28.7778 29.7273 27.7399 27.8889 25.6667 27.8889C23.5935 27.8889 22.5555 30.2055 22.5555 30.2055V23.6312Z",
    fill: "#226ED4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.9b18ea8e94f98b228ee47939d5eb32d2.svg";
export { ForwardRef as ReactComponent };